import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { CLIENT_PORTAL_HOME_ROUTE } from 'src/features/client-portal/components/shell/constants';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';

// TODO: Refactor shared/utils/routing/get-return-url.ts so that it can be used
// here instead, alongside auth guards.

function Redirect() {
  const auth = useAuth();
  const router = useRouter();

  const { user, isAuthenticated } = auth;

  const handleClientRedirect = () => {
    router.push(CLIENT_PORTAL_HOME_ROUTE);
  };

  const handleNonClientRedirect = () => {
    router.push('/advisor');
  };

  useEffect(() => {
    if (!isAuthenticated || !user) {
      router.push('/login');
    } else if (user.role === 'CLIENT') {
      handleClientRedirect();
    } else if (user.role === 'NON_ADVISORY_USER') {
      router.push('/portfolio');
    } else {
      handleNonClientRedirect();
    }
  }, [auth, router]);

  return null;
}

export default Redirect;
